import React from "react";
import GradientBar from "./components/common/GradientBar";
import Navbar from "./components/Navbar";

const AppShell = ({ children }) => (
  <>
    <GradientBar />
    <Navbar />
    <main className="flex-1 overflow-y-auto bg-gray-50 flex flex-col">
      <div className="max-w-7xl w-full mx-auto px-6 sm:px-8 py-8 flex flex-col flex-1 min-h-full">
        {children}
      </div>
    </main>
  </>
);

export default AppShell;
